__turbopack_context__.v({
  "actionButton": "cLu0Eq_actionButton",
  "backButton": "cLu0Eq_backButton",
  "buttonGroup": "cLu0Eq_buttonGroup",
  "cancelButton": "cLu0Eq_cancelButton",
  "checkboxLabel": "cLu0Eq_checkboxLabel",
  "checkmark": "cLu0Eq_checkmark",
  "colorGrid": "cLu0Eq_colorGrid",
  "colorOption": "cLu0Eq_colorOption",
  "colorSection": "cLu0Eq_colorSection",
  "createNewButton": "cLu0Eq_createNewButton",
  "createTagContent": "cLu0Eq_createTagContent",
  "deleteButton": "cLu0Eq_deleteButton",
  "deleteConfirmActions": "cLu0Eq_deleteConfirmActions",
  "deleteConfirmDialog": "cLu0Eq_deleteConfirmDialog",
  "deleteConfirmOverlay": "cLu0Eq_deleteConfirmOverlay",
  "editButton": "cLu0Eq_editButton",
  "emptyState": "cLu0Eq_emptyState",
  "errorLine": "cLu0Eq_errorLine",
  "headerActions": "cLu0Eq_headerActions",
  "headerTitle": "cLu0Eq_headerTitle",
  "hiddenPopout": "cLu0Eq_hiddenPopout",
  "inputGroup": "cLu0Eq_inputGroup",
  "leftSide": "cLu0Eq_leftSide",
  "loadMoreButton": "cLu0Eq_loadMoreButton",
  "loadingState": "cLu0Eq_loadingState",
  "popoutContainer": "cLu0Eq_popoutContainer",
  "popoutHeader": "cLu0Eq_popoutHeader",
  "searchContainer": "cLu0Eq_searchContainer",
  "searchIcon": "cLu0Eq_searchIcon",
  "searchInput": "cLu0Eq_searchInput",
  "selectedColor": "cLu0Eq_selectedColor",
  "tagCheckbox": "cLu0Eq_tagCheckbox",
  "tagItem": "cLu0Eq_tagItem",
  "tagNameInput": "cLu0Eq_tagNameInput",
  "tagsList": "cLu0Eq_tagsList",
  "updateButton": "cLu0Eq_updateButton",
});
